import {
    FilterData,
    FilterBlockTypesEnum,
} from "../../src/apis/stateful-content";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: FilterData = {
    filterBlocks: [
        {
            type: FilterBlockTypesEnum.Checkbox,
            filterItems: [
                {
                    name: "favorites",
                    value: "yes",
                    label: "Nur Favoriten",
                    active: false,
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Checkbox,
            filterItems: [
                {
                    name: "downloads",
                    value: "yes",
                    label: "Mit Downloads",
                    active: false,
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Checkbox,
            filterItems: [
                {
                    name: "options",
                    value: "yes",
                    label: "Mit Optionen",
                    active: false,
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Checkbox,
            filterItems: [
                {
                    name: "serviceagreements",
                    value: "yes",
                    label: "Mit Servicevereinbarungen",
                    active: false,
                },
            ],
        },
    ],
};

const writeToFile = (object: FilterData, name: string) => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "mysoftware-filter");
